import { Swiper, SwiperSlide } from "swiper/react";
import { EffectCoverflow, Pagination, Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/pagination";

const supportServices = [
    {
        title: "Pharmacy",
        desc: "24×7 in-house pharmacy with genuine medicines.",
        img: "/images/Services/support/pharmacy.jpg",
    },
    {
        title: "Ambulance",
        desc: "24×7 emergency ambulance services.",
        img: "/images/Services/support/ambulance.jpg",
    },
    {
        title: "Lift Services",
        desc: "Patient-friendly lift services for easy movement between floors.",
        img: "/images/Services/support/lift.jpg",
    },
    {
        title: "Waiting Area",
        desc: "Comfortable and clean waiting area for patients and attendants.",
        img: "/images/Services/support/waiting-area.jpg",
    },
    {
        title: "Wheelchair / Ramps",
        desc: "Easy access facilities for elderly and disabled patients.",
        img: "/images/Services/support/wheelchair.jpg",
    },
    {
        title: "Parking Facilities",
        desc: "Spacious and secure parking area for visitors and staff.",
        img: "/images/Services/support/parking.jpg",
    },
];

export default function SupportServices3D() {
    return (
        <section className="py-16">
            <div className="max-w-7xl mx-auto px-4">

                {/* 🔵 MAIN BOX */}
                <div
                    className="rounded-3xl shadow-2xl p-10"
                    style={{
                        background:
                            "linear-gradient(135deg, #0b3c78, #1e6fd9, #7cc7f5, #e7b7f3, #fde7f3)",
                    }}
                >
                    <h2 className="text-3xl font-bold text-center text-white mb-12">
                        Support Services
                    </h2>

                    <Swiper
                        effect="coverflow"
                        grabCursor
                        centeredSlides
                        slidesPerView="auto"
                        loop
                        autoplay={{ delay: 3000 }}
                        coverflowEffect={{
                            rotate: 30,
                            stretch: 0,
                            depth: 120,
                            modifier: 1,
                            slideShadows: true,
                        }}
                        pagination={{ clickable: true }}
                        modules={[EffectCoverflow, Pagination, Autoplay]}
                        className="max-w-6xl mx-auto"
                    >
                        {supportServices.map((item, index) => (
                            <SwiperSlide key={index} style={{ width: "320px" }}>
                                <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
                                    <img
                                        src={item.img}
                                        alt={item.title}
                                        className="w-full h-48 object-cover"
                                    />
                                    <div className="p-6 text-center">
                                        <h3 className="text-lg font-semibold text-gray-800">
                                            {item.title}
                                        </h3>
                                        <p className="text-sm text-gray-600 mt-2">
                                            {item.desc}
                                        </p>
                                    </div>
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>

                </div>
            </div>
        </section>
    );
}
